import { capitalizeWords } from "../capitalizeText"

export const onFormatPurchaseStatus = (status: string) => {
	const name = capitalizeWords(status);
    switch (status) {
        case 'approved':
            return { name, color: 'border-[#1389e6]', text: 'text-[#1389e6]' }
        case 'invoiced':
		case 'draft':
		case 'pending':
            return { name, color: 'border-[#f7a21e]', text: 'text-[#f7a21e]' }
        case 'match':
            return { name, color: 'border-[#00b67a]', text: 'text-[#00b67a]' }
        case 'mismatch':
		case 'rejected':
            return { name, color: 'border-[#E50000]', text: 'text-[#E50000]' }
        default:
            return { name, color: 'border-[#1389e6]', text: 'text-[#1389e6]' }
    }
}